<ng-container *ngIf="activeFiltersCount === 0">No filters applied</ng-container>
<ng-container *ngIf="activeFiltersCount === 1">1 filter applied</ng-container>
<ng-container *ngIf="activeFiltersCount > 1">{{activeFiltersCount}} filters applied</ng-container>
